// @owlcat/theme — the fleet's shared client-side theme boundary + pre-hydration seed.
//
// Usage in a root layout:
//   import { ThemeProvider, ThemeSeed } from "@owlcat/theme";
//   import { locales } from "@/lib/i18n/routing";
//   ...
//   <body>
//     <ThemeSeed />
//     <ThemeProvider locales={locales}>{children}</ThemeProvider>
//   </body>
export { ThemeProvider, ThemeCookieSync, FLEET_LOCALES } from "./ThemeProvider";
export { parseThemeCookie } from "./theme-cookie";
export { ThemeSeed } from "./ThemeSeed";
export { THEME_SEED } from "./theme-seed";
export { useTheme } from "next-themes";
